import React from "react";
import CustomButton from "../common/CustomButton";
import { useNavigate } from "react-router-dom";
import CustomFilterDropdown from "../common/CustomFilterDropdown";

const HeroSection = ({
  title = "Your Adventure Awaits Where Every Experience Is a Story.",
  description = "Book Unique experience and stay hosted by locals who share your passion for adventure",
  showSearchBar = true,
  searchPlaceholder = "Search...",
  searchValue = "",
  onSearchChange,
  home = false,
  filterOptions,
  cateogry,
  location,
  duration,
  sorting,
  expDetails = false,
}) => {
  const navigate = useNavigate();
  return (
    <div className="hero-main-user bg-cover bg-center min-h-[280px] sm:min-h-[320px] md:min-h-[420px] lg:min-h-[560px] flex justify-center items-center py-8 sm:py-10 md:py-12">
      <div className="flex flex-col justify-center items-center text-center px-4 sm:px-6 md:px-10 xl:px-32 w-full max-w-[1200px]">
        {/* TITLE */}
        <h1 className="text-white text-[20px] sm:text-[26px] md:text-[36px] lg:text-[48px] font-[600] tracking-[0.5px] lg:leading-[55px]">
          {title}
        </h1>

        {/* DESCRIPTION */}
        <p className="text-white text-[14px] sm:text-[16px] md:text-[20px] pt-2 md:pt-4 pb-4 md:pb-8 max-w-[900px]">
          {description}
        </p>

        {/* SEARCH BAR */}
        {showSearchBar && (
          <div
            className="
              mt-[55px]
              md:mt-0
              w-full
              sm:w-[90%]
              md:w-[70%]
              lg:w-[600px]
              bg-white
              rounded-full
              px-4
              py-2
              flex
              items-center
              gap-2
              shadow-lg
            "
          >
            {/* Search Icon */}
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0"
            >
              <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 21L16.7 16.7"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {/* INPUT */}
            <input
              type="search"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(e) => onSearchChange?.(e.target.value)}
              className="
                min-w-0
                flex-1
                py-2
                px-2
                outline-none
                text-[14px]
                sm:text-[15px]
                md:text-[16px]
              "
            />
          </div>
        )}

        {home && (
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mt-6 w-full max-w-[500px]">
            <CustomButton
              className="w-full sm:w-auto px-6 py-3 text-[15px] bg-[#0B1E2D] hover:bg-[#163447] transition-colors duration-200"
              onClick={() => {
                navigate("/experiences");
              }}
            >
              Explore Experiences
            </CustomButton>

            <CustomButton
              className="w-full sm:w-auto px-6 py-3 text-[15px]"
              onClick={() => {
                navigate("/signup");
              }}
            >
              Become a host
            </CustomButton>
          </div>
        )}

        {expDetails && (
          <div className="mt-6 flex w-full justify-center">
            <div className="grid w-full max-w-xl grid-cols-1 gap-2 sm:max-w-2xl sm:grid-cols-2 lg:w-auto lg:max-w-none lg:grid-cols-4 sm:gap-3">
              <CustomFilterDropdown
                fullWidth
                options={filterOptions?.categories}
                placeholder="Category"
                valueKey="id"
                labelKey="name"
                onChange={(item) => cateogry(item)}
              />

              <CustomFilterDropdown
                fullWidth
                options={filterOptions?.locations}
                placeholder="Location"
                valueKey="label"
                labelKey="label"
                onChange={(item) => location(item)}
              />

              <CustomFilterDropdown
                fullWidth
                options={filterOptions?.durations}
                placeholder="Duration"
                valueKey="id"
                labelKey="name"
                onChange={(item) => duration(item)}
              />

              <CustomFilterDropdown
                fullWidth
                options={filterOptions?.sort}
                placeholder="Sort By"
                valueKey="id"
                labelKey="name"
                onChange={(item) => sorting(item)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
